import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import InspectionDetail from "@/components/InspectionDetail";

/**
 * InspectionDetailPage — full-page render of the inspection. Feb 23:
 * Josh: "just seams like it needs a full page to see the inspection".
 *
 * Reuses the existing `<InspectionDetail>` component with `mode="page"`
 * so every existing behaviour (OK/ISSUE/N/A live-save, wear pin editor,
 * photos, sign-off, send-back, delete, PDF download, email, Raise-PPF
 * flow) works unchanged. Just gives the checklist the whole viewport
 * instead of a wedged drawer.
 */
export default function InspectionDetailPage() {
  const { id } = useParams();
  const nav = useNavigate();
  return (
    <div className="min-h-screen">
      <div className="px-5 pt-4">
        <button
          onClick={() => nav(-1)}
          className="btn btn-sm btn-ghost"
          data-testid="inspection-page-back"
          title="Back to the previous page"
        >
          <ArrowLeft className="w-4 h-4" /> Back
        </button>
      </div>
      <InspectionDetail
        inspectionId={id}
        mode="page"
        onClose={() => nav(-1)}
        onUpdated={() => { /* live-save handles refresh; no parent list to refresh here */ }}
      />
    </div>
  );
}
